import "flag-icons/css/flag-icons.min.css";

import type { CSSProperties, ReactNode } from "react";

interface FlagIconsFlagProps {
  region: string;
  size: number;
}

/** Owns the stylesheet and dynamic class contract of the flag-icons package. */
export function FlagIconsFlag({ region, size }: FlagIconsFlagProps): ReactNode {
  const style: CSSProperties = {
    width: size,
    height: size * 0.75,
  };

  return (
    <span
      style={style}
      aria-hidden="true"
      // These classes are the public runtime contract of flag-icons, not Tailwind utilities.
      // oxlint-disable-next-line tailwindcss/no-unknown-classes
      className={`fi fi-${region} inline-flex shrink-0`}
      data-testid="language-indicator"
    />
  );
}
